import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";

@Component({})
export default class RiskAssessmentCheckList extends Vue {
  @Prop(String)
  title!: string;

  @Prop(Object)
  data!: Record<string, any>;

  @Prop(Array)
  assess!: Array<any>;

  @Prop(Boolean)
  disabled!: boolean;

  @Emit()
  riskUpdate() {
    return this.list;
  }

  list: Array<any> = [];

  mounted() {
    this.list = Object.keys(this.data).map(key => {
      const value = this.data[key].value;

      let text = this.assess[this.data[key].index].text;
      const other = key.startsWith("Other");
      if (other) {
        text = this.data[key].text;
      }
      return { value, text, other, key };
    });
    // Send initial values back up
    this.riskUpdate();
  }

  inputChange() {
    this.riskUpdate();
    this.checkIfAdd();
  }

  checkIfAdd() {
    const last = this.list[this.list.length - 1];
    if (last.other && last.text && last.value) {
      const oldIdParts = last.key.split(".");
      oldIdParts[2]++;
      const newKey = oldIdParts.join(".");
      const newItem = {
        key: newKey,
        text: "",
        value: 0,
        other: true
      };
      this.list.push(newItem);
    }
  }
}
